import React from 'react'
import { useForm } from 'react-hook-form'
import { Form } from 'react-bootstrap'
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap'
import { message } from 'antd'

import DepartmentForm from './DepartmentForm'

import { updateDepartment } from '../services'
import { handleError } from '../../../helpers'

export default function EditDepartmentModal({ visible, onClose, reload, department }) {
	const { register, handleSubmit, formState: { errors } } = useForm({
		defaultValues: department
	})

	const onSubmit = values => {
		updateDepartment(department.id, values)
			.then(res => {
				message.success(res.data.message)
				reload()
			})
			.catch(error => handleError(error))
	}

	return (
		<React.Fragment>
			<Modal isOpen={visible} toggle={onClose}>
				<ModalHeader toggle={onClose}>Actualizar Registro</ModalHeader>
				<ModalBody>
					<Form onSubmit={handleSubmit(onSubmit)}>
						<DepartmentForm register={register} errors={errors} department={department} />
						<Button color="primary" type="submit">Actualizar Registrar</Button>
					</Form>
				</ModalBody>
			</Modal>
		</React.Fragment>
	)
}